import { put, call } from "redux-saga/effects";
import { alertConstants, authConstants, jointReportConstants } from "_constants";

import { jointReportsService } from "_services";

export function* getUserReportsSaga() {
  try {
    const response = yield call(jointReportsService.getUserReports);

    yield put({
      type: jointReportConstants.GET_USER_REPORTS_SUCCESS,
      payload: response,
    });
  } catch (error) {
    if (error.message === "Invalid Auth Token") {
      yield put({
        type: authConstants.LOGOUT,
      });
    }
    yield put({
      type: alertConstants.ERROR,
      payload: { message: error.message },
    });
  }
}

export function* getReportSaga({ reportID }) {
  try {
    const response = yield call(jointReportsService.getReport, reportID);

    yield put({
      type: jointReportConstants.GET_REPORT_SUCCESS,
      payload: {
        reportID,
        data: response,
      },
    });
  } catch (error) {
    if (error.message === "Invalid Auth Token") {
      yield put({
        type: authConstants.LOGOUT,
      });
    }
    yield put({
      type: alertConstants.ERROR,
      payload: { message: error.message },
    });
  }
}

export function* getReportsProcsSaga() {
  try {
    const response = yield call(jointReportsService.getProcs);

    yield put({
      type: jointReportConstants.GET_REPORT_PROCS_SUCCESS,
      payload: response,
    });
  } catch (error) {
    if (error.message === "Invalid Auth Token") {
      yield put({
        type: authConstants.LOGOUT,
      });
    }
    yield put({
      type: alertConstants.ERROR,
      payload: { message: error.message },
    });
  }
}

export function* queryReportsProcSaga({ lob, filters, fields, inputs, reportName, shared, rowsPerPage, page }) {
  try {
    // put: loading true
    yield put({
      type: jointReportConstants.QUERY_REPORT_PROC_LOADING,
    });

    const response = yield call(
      jointReportsService.queryProc,
      lob,
      filters,
      fields,
      inputs,
      reportName,
      shared,
      rowsPerPage,
      page
    );
    yield put({
      type: jointReportConstants.QUERY_REPORT_PROC_SUCCESS,
      payload: {
        lob,
        filters,
        fields,
        inputs,
        reportName,
        shared,
        rowsPerPage,
        page,
        data: response,
      },
    });
  } catch (error) {
    if (error.message === "Invalid Auth Token") {
      yield put({
        type: authConstants.LOGOUT,
      });
    }
    yield put({
      type: alertConstants.ERROR,
      payload: { message: error.message },
    });
  }
}

export function* getScoreboardSaga({ startDate }) {
  try {
    const result = yield call(jointReportsService.getScoreboard, startDate);

    const { response, directorView } = result;

    if (response) {
      const [header, targets, stats] = response;
      yield put({
        type: jointReportConstants.GET_SCORE_BOARD_SUCCESS,
        payload: { header, targets, stats, directorView },
      });
    }
  } catch (error) {
    if (error.message === "Invalid Auth Token") {
      yield put({
        type: authConstants.LOGOUT,
      });
    }
    yield put({
      type: alertConstants.ERROR,
      payload: { message: error.message },
    });
  }
}

export function* getAListReportSaga({ regionId, marketId, entityId }) {
  try {
    yield put({
      type: jointReportConstants.GET_A_LIST_REPORT_LOADING_TRUE,
    });
    const result = yield call(jointReportsService.getAList, regionId, marketId, entityId);

    let { response } = result;

    if (response) {
      yield put({
        type: jointReportConstants.GET_A_LIST_REPORT_SUCCESS,
        payload: { data: response, marketId, regionId, entityId },
      });
    }
  } catch (error) {
    if (error.message === "Invalid Auth Token") {
      yield put({
        type: authConstants.LOGOUT,
      });
    }
    yield put({
      type: alertConstants.ERROR,
      payload: { message: error.message },
    });
  }
}

export function* getRemittanceSaga({ payload }) {
  try {
    const response = yield call(jointReportsService.getRemittance, payload);

    if (response && response.data) {
      yield put({
        type: jointReportConstants.GET_REMITTANCE_SUCCESS,
        payload: {
          data: response.data,
          entityIDs: payload.entityIDs,
        },
      });
    }
  } catch (error) {
    if (error.message === "Invalid Auth Token") {
      yield put({
        type: authConstants.LOGOUT,
      });
    }

    yield put({
      type: jointReportConstants.GET_REMITTANCE_FAILURE,
      payload: { error: error.message },
    });

    yield put({
      type: alertConstants.ERROR,
      payload: { message: error.message },
    });
  }
}
export function* getEntityRemittanceTemplateSaga({ payload }) {
  const { entityId } = payload;
  try {
    const response = yield call(jointReportsService.getEntityRemittanceTemplate, entityId);
    const { data } = response;

    if (response) {
      yield put({
        type: jointReportConstants.GET_REMITTANCE_TEMPLATE_SUCCESS,
        payload: { data },
      });
    }
  } catch (error) {
    if (error.message === "Invalid Auth Token") {
      yield put({
        type: authConstants.LOGOUT,
      });
    }

    yield put({
      type: jointReportConstants.GET_REMITTANCE_TEMPLATE_FAILURE,
      payload: { error: error.message },
    });

    yield put({
      type: alertConstants.ERROR,
      payload: { message: error.message },
    });
  }
}

export function* updateEntityRemittanceTemplateSaga({ payload }) {
  const { entityId, templateData } = payload;
  try {
    const response = yield call(jointReportsService.updateEntityRemittanceTemplate, entityId, templateData);
    const { data } = response;

    if (response) {
      yield put({
        type: jointReportConstants.UPDATE_REMITTANCE_TEMPLATE_SUCCESS,
        payload: { data, templateData },
      });

      yield put({
        type: alertConstants.SUCCESS,
        payload: { message: "Template updated successfully!" },
      });
    }
  } catch (error) {
    if (error.message === "Invalid Auth Token") {
      yield put({
        type: authConstants.LOGOUT,
      });
    }

    yield put({
      type: jointReportConstants.UPDATE_REMITTANCE_TEMPLATE_FAILURE,
      payload: { error: error.message },
    });

    yield put({
      type: alertConstants.ERROR,
      payload: { message: error.message },
    });
  }
}
